
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"10","viewBox":"0 0 12 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"}}),_c('path',{attrs:{"fill":"none","d":"M0 0h24v24H0z"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/sidebar/closeWindowArrow.svg